/**
 * @module Theme
 */

import { Component, Input } from '@angular/core';
import { ItemColor } from '@functions/item.functions';
import { ThemeOptionsClass } from '@class/themeOptions.class';
import { ThemeOptionType } from '@models/themeStudio.model';

@Component({
  selector: 'app-theme-option-tooltips-body-font-color',
  templateUrl: './theme-option-tooltips-body-font-color.component.html',
  styleUrls: ['./theme-option-tooltips-body-font-color.component.css']
})
export class ThemeOptionTooltipsBodyFontColorComponent {

  @Input() themeOptions: ThemeOptionsClass;

  color = ItemColor('themes');
  optionType: ThemeOptionType = 'tooltips_bodyFontColor';

  constructor() {}
  
  receiveValue(value: string) {
    this.themeOptions.setOption('tooltips_bodyFontColor', value);
  }

}
